import { useMutation } from '@apollo/client/react';
import { loggerService } from '@brainpool/logger';
import { DELETE_CASE } from '../queries/DeleteCase';
import { LoggerContextProps } from '../types/LogContext';
import { LIST_CASES } from '../queries/ListCases';
import { handleError } from './errorHandler';

export function useDeleteCase() {
  const context: LoggerContextProps = {
    action: 'deleteCases',
  };

  const [deleteCaseQuery, { data, loading, error }] = useMutation<{
    deleteCase: {
      success: boolean;
    };
  }>(DELETE_CASE, {
    refetchQueries: [{ query: LIST_CASES }],
    awaitRefetchQueries: true,
  });

  const deleteCase = async (ids: string[]) => {
    try {
      const { data } = await deleteCaseQuery({
        variables: { ids },
      });
      if (data?.deleteCase?.success) {
        loggerService.log({
          message: `Projects deleted successfully.`,
          logLevel: 'success',
          context,
          userMessage: { message: `Projects deleted successfully.` },
        });
      }
    } catch (error) {
      handleError(error, context, 'Failed to delete cases.');
    }
  };

  return { deleteCase, data, loading, error };
}
